﻿{
  "US": "Stany Zjednoczone",
  "AF": "Afganistan",
  "AX": "Wyspy Alandzkie",
  "AL": "Albania",
  "DZ": "Algieria",
  "AS": "Amerykańskie Samoa",
  "AD": "Andora",
  "AO": "Angola",
  "AI": "Anguilla",
  "AQ": "Antarktyka",
  "AG": "Antigua i Barbuda",
  "AR": "Argentyna",
  "AM": "Armenia",
  "AW": "Aruba",
  "AU": "Australia",
  "AT": "Austria",
  "AZ": "Azerbejdżan",
  "BS": "Bahamy",
  "BH": "Bahrajn",
  "BD": "Bangladesz",
  "BB": "Barbados",
  "BY": "Białoruś",
  "BE": "Belgia",
  "BZ": "Belize",
  "BJ": "Benin",
  "BM": "Bermudy",
  "BT": "Bhutan",
  "BO": "Boliwia",
  "BA": "Bośnia i Hercegowina",
  "BW": "Botswana",
  "BV": "Wyspa Bouvet",
  "BR": "Brazylia",
  "IO": "Brytyjskie Terytorium Oceanu Indyjskiego",
  "BN": "Brunei Darussalam",
  "BG": "Bułgaria",
  "BF": "Burkina Faso",
  "BI": "Burundi",
  "KH": "Kambodża",
  "CM": "Kamerun",
  "CA": "Kanada",
  "CV": "Republika Zielonego Przylądka",
  "KY": "Kajmany",
  "CF": "Republika Środkowoafrykańska",
  "TD": "Czad",
  "CL": "Chile",
  "CN": "Chiny",
  "CX": "Wyspa Bożego Narodzenia",
  "CC": "Wyspy Kokosowe (Keelinga)",
  "CO": "Kolumbia",
  "KM": "Komory",
  "CG": "Kongo",
  "CD": "Kongo, Demokratyczna Republika Konga",
  "CK": "Wyspy Cooka",
  "CR": "Kostaryka",
  "CI": "Wybrzeże Kości Słoniowej",
  "HR": "Chorwacja",
  "CU": "Kuba",
  "CY": "Cypr",
  "CZ": "Czechy",
  "DK": "Dania",
  "DJ": "Dżibuti",
  "DM": "Dominika",
  "DO": "Dominikana",
  "EC": "Ekwador",
  "EG": "Egipt",
  "SV": "Salwador",
  "GQ": "Gwinea Równikowa",
  "ER": "Erytrea",
  "EE": "Estonia",
  "ET": "Etiopia",
  "FK": "Falklandy (Malwiny)",
  "FO": "Wyspy Owcze",
  "FJ": "Fidżi",
  "FI": "Finlandia",
  "FR": "Francja",
  "GF": "Gujana Francuska",
  "PF": "Polinezja Francuska",
  "TF": "Francuskie Terytoria Południowe",
  "GA": "Gabon",
  "GM": "Gambia",
  "GE": "Gruzja",
  "DE": "Niemcy",
  "GH": "Ghana",
  "GI": "Gibraltar",
  "GR": "Grecja",
  "GL": "Grenlandia",
  "GD": "Grenada",
  "GP": "Gwadelupa",
  "GU": "Guam",
  "GT": "Gwatemala",
  "GG": "Guernsey",
  "GN": "Gwinea",
  "GW": "Gwinea Bissau",
  "GY": "Gujana",
  "HT": "Haiti",
  "HM": "Wyspy Heard i McDonald",
  "VA": "Stolica Apostolska (Watykan)",
  "HN": "Honduras",
  "HK": "Hongkong",
  "HU": "Węgry",
  "IS": "Islandia",
  "IN": "Indie",
  "ID": "Indonezja",
  "IR": "Iran, Islamska Republika Iranu",
  "IQ": "Irak",
  "IE": "Irlandia",
  "IM": "Wyspa Man",
  "IL": "Izrael",
  "IT": "Włochy",
  "JM": "Jamajka",
  "JP": "Japonia",
  "JE": "Jersey",
  "JO": "Jordania",
  "KZ": "Kazachstan",
  "KE": "Kenia",
  "KI": "Kiribati",
  "KR": "Korea",
  "KW": "Kuwejt",
  "KG": "Kirgistan",
  "LA": "Laotańska Republika Ludowo-Demokratyczna",
  "LV": "Łotwa",
  "LB": "Liban",
  "LS": "Lesotho",
  "LR": "Liberia",
  "LY": "Arabska Libijska Dżamahirijja",
  "LI": "Liechtenstein",
  "LT": "Litwa",
  "LU": "Luksemburg",
  "MO": "Makao",
  "MK": "Macedonia",
  "MG": "Madagaskar",
  "MW": "Malawi",
  "MY": "Malezja",
  "MV": "Malediwy",
  "ML": "Mali",
  "MT": "Malta",
  "MH": "Wyspy Marshalla",
  "MQ": "Martynika",
  "MR": "Mauretania",
  "MU": "Mauritius",
  "YT": "Wyspa Majotta",
  "MX": "Meksyk",
  "FM": "Mikronezja, Sfederowane Stany Mikronezji",
  "MD": "Mołdawia",
  "MC": "Monako",
  "MN": "Mongolia",
  "ME": "Czarnogóra",
  "MS": "Montserrat",
  "MA": "Maroko",
  "MZ": "Mozambik",
  "MM": "Myanmar",
  "NA": "Namibia",
  "NR": "Nauru",
  "NP": "Nepal",
  "NL": "Holandia",
  "AN": "Antyle Holenderskie",
  "NC": "Nowa Kaledonia",
  "NZ": "Nowa Zelandia",
  "NI": "Nikaragua",
  "NE": "Niger",
  "NG": "Nigeria",
  "NU": "Niue",
  "NF": "Wyspa Norfolk",
  "MP": "Mariany Północne",
  "NO": "Norwegia",
  "OM": "Oman",
  "PK": "Pakistan",
  "PW": "Palau",
  "PS": "Okupowane terytoria palestyńskie",
  "PA": "Panama",
  "PG": "Papua Nowa Gwinea",
  "PY": "Paragwaj",
  "PE": "Peru",
  "PH": "Filipiny",
  "PN": "Pitcairn",
  "PL": "Polska",
  "PT": "Portugalia",
  "PR": "Portoryko",
  "QA": "Katar",
  "RE": "Wyspa Reunion",
  "RO": "Rumunia",
  "RU": "Federacja Rosyjska",
  "RW": "Ruanda",
  "BL": "Saint-Barthélemy",
  "SH": "Święta Helena",
  "KN": "Saint Kitts i Nevis",
  "LC": "Saint Lucia",
  "MF": "Saint Martin",
  "PM": "Saint Pierre i Miquelon",
  "VC": "Saint Vincent i Grenadyny",
  "WS": "Samoa",
  "SM": "San Marino",
  "ST": "Wyspy Świętego Tomasza i Książęca",
  "SA": "Arabia Saudyjska",
  "SN": "Senegal",
  "RS": "Serbia",
  "SC": "Seszele",
  "SL": "Sierra Leone",
  "SG": "Singapur",
  "SK": "Słowacja",
  "SI": "Słowenia",
  "SB": "Wyspy Salomona",
  "SO": "Somalia",
  "ZA": "Republika Południowej Afryki",
  "GS": "Georgia Południowa i Sandwich Płd.",
  "ES": "Hiszpania",
  "LK": "Sri Lanka",
  "SD": "Sudan",
  "SR": "Surinam",
  "SJ": "Svalbard i Jan Mayen",
  "SZ": "Suazi",
  "SE": "Szwecja",
  "CH": "Szwajcaria",
  "SY": "Syryjska Republika Arabska",
  "TW": "Tajwan",
  "TJ": "Tadżykistan",
  "TZ": "Tanzania",
  "TH": "Tajlandia",
  "TL": "Timor-Leste",
  "TG": "Togo",
  "TK": "Tokelau",
  "TO": "Tonga",
  "TT": "Trynidad i Tobago",
  "TN": "Tunezja",
  "TR": "Turcja",
  "TM": "Turkmenistan",
  "TC": "Wyspy Turks i Caicos",
  "TV": "Tuvalu",
  "UG": "Uganda",
  "UA": "Ukraina",
  "AE": "Zjednoczone Emiraty Arabskie",
  "GB": "Wielka Brytania",
  "UM": "Dalekie Wyspy Mniejsze Stanów Zjednoczonych",
  "UY": "Urugwaj",
  "UZ": "Uzbekistan",
  "VU": "Vanuatu",
  "VE": "Wenezuela",
  "VN": "Wietnam",
  "VG": "Wyspy Dziewicze (W. Br.)",
  "VI": "Wyspy Dziewicze (USA)",
  "WF": "Wallis i Futuna",
  "EH": "Sahara Zachodnia",
  "YE": "Jemen",
  "ZM": "Zambia",
  "ZW": "Zimbabwe"
}
